import { ApdmImportState } from '@euler/functions/apdm/import/importState';
import { useConfirm } from '@euler/functions/ux/useConfirm';
import { View } from 'react-native';
import { ReviewAction, ReviewActionTone } from '../../ReviewControls';

/** Start the import from its summary, or take it back out. */
export function ImportActions({
  state,
  starting,
  deleting,
  onStart,
  onDelete,
}: {
  state: ApdmImportState;
  starting: boolean;
  deleting: boolean;
  onStart: () => void;
  onDelete: () => void;
}) {
  const confirm = useConfirm();
  const startable =
    state.kind === 'ready' || (state.kind === 'failed' && state.restartable);
  const deletable =
    state.kind !== 'publishing' &&
    state.kind !== 'deleted' &&
    state.kind !== 'working';
  return (
    <View>
      {startable ? (
        <ReviewAction
          title={state.kind === 'ready' ? '开始导入' : '重新开始导入'}
          loading={starting}
          disabled={deleting}
          onPress={onStart}
        />
      ) : null}
      {deletable ? (
        <ReviewAction
          title="删除这次导入"
          tone={ReviewActionTone.Destructive}
          loading={deleting}
          disabled={starting}
          onPress={() => {
            void (async () => {
              const confirmed = await confirm({
                title: '删除这次导入？',
                message:
                  state.kind === 'published'
                    ? '这份文件导入的来店记录和保养到期都会撤回。'
                    : '这份文件不会再导入。',
                confirmButtonText: '删除',
                destructive: true,
              });
              if (confirmed) onDelete();
            })();
          }}
        />
      ) : null}
    </View>
  );
}
